import * as z from "zod";

export const ProcessOrderValidationSchema = z.object({
  startDate: z.date().optional(),
  endDate: z.date().optional(),
});

export type ProcessOrderFormInput = z.infer<typeof ProcessOrderValidationSchema>;
